/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Config from '@/config';
import { useTranslations } from 'next-intl';



//Build the Element
export default function ReadTime({ article, ...props }){

    const t = useTranslations();

    //Return
    return (
        <time>
            <i aria-hidden="true" className="far fa-clock"></i> {
                t.rich('Pages.Blog.read-time',{
                    ...Config.i18n.html,
                    time: Math.ceil( article.content.split(' ').length / 200 )
                })
            }
        </time>
    );

}